import { WeatherMobile } from "./WeatherMobile";
export default WeatherMobile;
